import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { deleteCharity } from '../CharityOperations';
import { map, pick } from 'lodash';
import { Link } from 'react-router-dom';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import * as moment from 'moment';
import TablePaginationActions from '../../TablePagination';
import Dialog from '../../Dialog';

const styles = theme => ({
  cell: {
    border: 'none',
    paddingTop: 12,
    paddingBottom: 12
  },
  roundBtn: {
    height: 40,
    width: 40,
    boxShadow: 'none',
    margin: '0 5px'
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  }
});

export interface CharitiesTableProps {
  charities: Array<any> ;
  classes: any;
  handleDelete: () => void;
  fullWidth: boolean;
}

export interface CharitiesTableState {
  page: number;
  rowsPerPage: number;
  open: boolean;
  id: number
}

class CharityTable extends React.Component<CharitiesTableProps, CharitiesTableState> {
  constructor(props) {
    super(props);
    this.state ={
      page: 0,
      rowsPerPage: 5,
      open: false,
      id:0
    }
  }
  handleChangePage = (event, page) => {
    this.setState({ page });
  };
  handleClickOpen = (id) => {
    this.setState({ open: true, id });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { classes, charities, handleDelete, fullWidth } = this.props;
    const { rowsPerPage, page, open, id } = this.state;
    const uids= Object.keys(charities || {});
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, uids.length - page * rowsPerPage);
    return (
      <div>
        <Table padding="checkbox">
          <TableHead>
            <TableRow>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">NAME</Typography></TableCell>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">DESCRIPTION</Typography></TableCell>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">DATE</Typography></TableCell>
              <TableCell className={!fullWidth ?classes.cell: ''}><Typography variant="title">ACTIONS</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {charities && map(pick(charities, uids.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)), ({ name, description, logoImgUrl, timestamp }, index) => {
              return (
                <TableRow key={index}>
                  <TableCell className={classes.cell}>
                    <div className={classes.flexContainer}>
                      <img src={logoImgUrl} width={70} />
                      <Typography variant="body2" style={{paddingLeft: 10}}>
                      {name}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body1">
                      {description.length > 100 ? `${description.substring(0, 100)}...` : description}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <Typography variant="body2">
                      {timestamp ? moment(timestamp).format('DD MMM YYYY') : "-"}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.cell}>
                    <div style={{display: 'flex', justifyContent: 'space-around'}}>
                      <Link to={`charities/edit/${index}`} >
                        <Button variant="fab"  className={classes.roundBtn}>
                          <EditIcon />
                        </Button>
                      </Link>
                      <Button variant="fab" color="default" className={classes.roundBtn} onClick={() => this.handleClickOpen(index)}>
                        <DeleteIcon />
                      </Button>
                    </div>
                  </TableCell>
                  
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
                <TableRow style={{ height: 60 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
 
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={12}
                count={uids.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                ActionsComponent={TablePaginationActions}
                rowsPerPageOptions={[]}
              />
            </TableRow>
          </TableFooter>
        </Table>
        <Dialog 
          open={open} 
          handleClose={this.handleClose} 
          action={() => handleDelete(id)} 
        />
      </div>
    );
  }
}

const mapStateToProps = ({ charities }) => ({ charities: charities.all });
const mapDispatchToProps = (dispatch) => ({
  handleDelete: (uid: string) => {
    return dispatch(deleteCharity(uid));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CharityTable));
